import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  extractTableBlock,
  splitByHeading,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelRepeatabilityScore = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Repeatability Score";
  const lines = stripTitleLines(cleanLines(markdown));
  const { table, before, after } = extractTableBlock(lines);

  const { tail: scoreSection } = splitByHeading(after, "Repeatability Score");
  const { lead: scoreLines, tail: interpretationSection } = splitByHeading(
    scoreSection,
    "Scoring Interpretation"
  );

  const scoreBullets = toBullets(scoreLines);
  let scoreParagraphs = toParagraphs(scoreLines);
  const scoreVerdict = extractVerdict(scoreParagraphs);
  if (scoreVerdict) scoreParagraphs = scoreParagraphs.slice(0, -1);

  const interpretationBullets = toBullets(interpretationSection);
  let interpretationParagraphs = toParagraphs(interpretationSection);
  const interpretationVerdict = extractVerdict(interpretationParagraphs);
  if (interpretationVerdict)
    interpretationParagraphs = interpretationParagraphs.slice(0, -1);

  return (
    <FunnelInsightCard
      title={title}
      kicker="Repeatability Index"
      sections={[
        {
          title: "Scoring Table",
          table,
          paragraphs: before.length ? toParagraphs(before) : [],
        },
        {
          title: "Repeatability Score",
          bullets: scoreBullets,
          paragraphs: scoreParagraphs,
          verdict: scoreVerdict,
        },
        {
          title: "Scoring Interpretation",
          bullets: interpretationBullets,
          paragraphs: interpretationParagraphs,
          verdict: interpretationVerdict,
        },
      ]}
    />
  );
};

export default FunnelRepeatabilityScore;
